export const isIOS = () => {
  const { userAgent } = navigator;

  return !!(userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i));
};

export const isAndroid = () => {
  const { userAgent } = navigator;

  return !!userAgent.match(/android/i);
};

export const isRN = () => {
  const { userAgent } = navigator;

  return userAgent.match(/classting_rn/i);
};

export const isWebView = () => {
  const { userAgent } = navigator;

  return !!(
    userAgent.match(/classting_android/i) || userAgent.match(/classting_iphone/i)
  );
};

export const callNative = (url) => {
  if (window.ctandroid !== undefined) {
    window.ctandroid.submitFromWeb(url);
  } else {
    window.location = url;
  }
};

export const getTokenFromNative = () => callNative('ctjscall://authorize?source=classting&callback=setToken');

export const closeWebView = () => callNative('ctjscall://close?source=classting');

export const enableZoom = () => callNative('ctjscall://zoom?is_enabled=1');

export const disableZoom = () => callNative('ctjscall://zoom?is_enabled=false');
